import { apiClient } from '../../../../../services/apiClient'
import type { FileResponse, FileListResponse } from '@popety-io/types'

export const buildingFilesService = {
  /**
   * Fetch files for a specific building
   */
  getByBuildingId: async (buildingId: string): Promise<FileListResponse> => {
    try {
      const response = await apiClient.get(`/files/building/${buildingId}`)
      return response.data
    } catch (error) {
      console.error('Get building files by building ID error:', error)
      throw error
    }
  },

  /**
   * Upload a new file for a building
   */
  uploadFile: async (
    id: string,
    file: File,
    type = 'building'
  ): Promise<FileResponse> => {
    try {
      const formDataObj = {
        file: file,
        entity_type: type,
        entity_id: id,
      }

      const response = await apiClient.post(`/files`, formDataObj, {
        formData: true,
      })

      return response.data
    } catch (error) {
      console.error('Upload building file error:', error)
      throw error
    }
  },

  /**
   * Delete a file
   */
  deleteFile: async (fileId: string): Promise<void> => {
    try {
      await apiClient.delete(`/files/${fileId}`)
    } catch (error) {
      console.error('Delete building file error:', error)
      throw error
    }
  },

  /**
   * Download a file
   */
  downloadFile: async (fileId: string): Promise<void> => {
    try {
      await apiClient.downloadFile(`/files/${fileId}/download`)
    } catch (error) {
      console.error('Download building file error:', error)
      throw error
    }
  },
}
